import React from 'react';

import './styles/style.scss';

import RadioCheck from './RadioCheck';

export const Radio = props => <RadioCheck type="radio" {...props} />;
Radio.displayName = 'Radio';

export const Checkbox = props => <RadioCheck type="checkbox" {...props} />;
Checkbox.displayName = 'Checkbox';



// WEBPACK FOOTER //
// ./src/components/Forms/RadioCheck/index.js